var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-header'),_c('div',{staticClass:"page"},[_c('h2',[_vm._v("Que souhaitez-vous faire ?")]),_c('img',{staticClass:"question",attrs:{"src":require("../../../assets/Question.svg")}}),_c('triple-bouton')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }